import React from 'react';

const PrivacyPolicy = () => {
  const isMobile = window.innerWidth <= 768;
  const isSmallMobile = window.innerWidth <= 480;
  
  return (
    <div style={{
      maxWidth: '100%',
      margin: '0 auto',
      padding: isSmallMobile ? '20px 10px' : isMobile ? '30px 15px' : '40px 20px',
      fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
      lineHeight: '1.6',
      color: '#333',
      fontSize: isSmallMobile ? '13px' : isMobile ? '14px' : '16px'
    }}>
      <h1 style={{
        fontSize: isSmallMobile ? '24px' : isMobile ? '28px' : '32px',
        fontWeight: 'bold',
        color: '#424242',
        marginBottom: isSmallMobile ? '20px' : isMobile ? '25px' : '30px',
        textAlign: 'center',
        lineHeight: isSmallMobile ? '1.3' : '1.4'
      }}>
        Polityka Prywatności
      </h1>

      <div style={{
        background: '#ffffff',
        borderRadius: isSmallMobile ? '8px' : isMobile ? '10px' : '12px',
        padding: isSmallMobile ? '20px 15px' : isMobile ? '25px 20px' : '40px',
        boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
        marginBottom: isSmallMobile ? '20px' : isMobile ? '25px' : '30px'
      }}>
        <h2 style={{ 
          fontSize: isSmallMobile ? '20px' : isMobile ? '22px' : '24px', 
          fontWeight: '600', 
          marginBottom: isSmallMobile ? '15px' : isMobile ? '18px' : '20px', 
          color: '#424242',
          lineHeight: isSmallMobile ? '1.3' : '1.4'
        }}>
          1. Informacje ogólne
        </h2>
        <p style={{ 
          marginBottom: isSmallMobile ? '12px' : isMobile ? '14px' : '15px',
          lineHeight: isSmallMobile ? '1.4' : '1.6'
        }}>
          Niniejsza Polityka Prywatności określa zasady przetwarzania danych osobowych w aplikacji Generator Liczb Lotto AI 
          (dalej "Aplikacja") przez administratora danych osobowych.
        </p>
        <p style={{ 
          marginBottom: isSmallMobile ? '12px' : isMobile ? '14px' : '15px',
          lineHeight: isSmallMobile ? '1.4' : '1.6'
        }}>
          <strong>Administrator danych osobowych:</strong><br />
          Michal Jedynasty<br />
          Email: kontakt@losuje.pl
        </p>

        <h2 style={{ 
          fontSize: isSmallMobile ? '20px' : isMobile ? '22px' : '24px', 
          fontWeight: '600', 
          marginBottom: isSmallMobile ? '15px' : isMobile ? '18px' : '20px', 
          color: '#424242', 
          marginTop: isSmallMobile ? '25px' : isMobile ? '28px' : '30px',
          lineHeight: isSmallMobile ? '1.3' : '1.4'
        }}>
          2. Zakres zbieranych danych
        </h2>
        <p style={{ 
          marginBottom: isSmallMobile ? '12px' : isMobile ? '14px' : '15px',
          lineHeight: isSmallMobile ? '1.4' : '1.6'
        }}>
          Aplikacja zbiera następujące kategorie danych osobowych:
        </p>
        <ul style={{ 
          marginBottom: isSmallMobile ? '12px' : isMobile ? '14px' : '15px', 
          paddingLeft: isSmallMobile ? '15px' : '20px',
          lineHeight: isSmallMobile ? '1.4' : '1.6'
        }}>
          <li>Dane identyfikacyjne: imię, nazwisko, adres email</li>
          <li>Dane techniczne: adres IP, informacje o urządzeniu i przeglądarce</li>
          <li>Dane użytkowania: preferencje gier, wygenerowane zestawy liczb, historię aktywności</li>
          <li>Dane płatności: informacje o subskrypcjach i płatnościach (przetwarzane przez zewnętrznych operatorów płatności)</li>
        </ul>

        <h2 style={{ 
          fontSize: isSmallMobile ? '20px' : isMobile ? '22px' : '24px', 
          fontWeight: '600', 
          marginBottom: isSmallMobile ? '15px' : isMobile ? '18px' : '20px', 
          color: '#424242', 
          marginTop: isSmallMobile ? '25px' : isMobile ? '28px' : '30px',
          lineHeight: isSmallMobile ? '1.3' : '1.4'
        }}>
          3. Cel przetwarzania danych
        </h2>
        <p style={{ 
          marginBottom: isSmallMobile ? '12px' : isMobile ? '14px' : '15px',
          lineHeight: isSmallMobile ? '1.4' : '1.6'
        }}>
          Dane osobowe są przetwarzane w następujących celach:
        </p>
        <ul style={{ 
          marginBottom: isSmallMobile ? '12px' : isMobile ? '14px' : '15px', 
          paddingLeft: isSmallMobile ? '15px' : '20px',
          lineHeight: isSmallMobile ? '1.4' : '1.6'
        }}>
          <li>Świadczenie usług generatora liczb lotto</li>
          <li>Personalizacja doświadczeń użytkownika</li>
          <li>Obsługa płatności i subskrypcji</li>
          <li>Komunikacja z użytkownikami</li>
          <li>Analiza i poprawa funkcjonalności aplikacji</li>
          <li>Zapewnienie bezpieczeństwa i zapobieganie nadużyciom</li>
        </ul>

        <h2 style={{ 
          fontSize: isSmallMobile ? '20px' : isMobile ? '22px' : '24px', 
          fontWeight: '600', 
          marginBottom: isSmallMobile ? '15px' : isMobile ? '18px' : '20px', 
          color: '#424242', 
          marginTop: isSmallMobile ? '25px' : isMobile ? '28px' : '30px',
          lineHeight: isSmallMobile ? '1.3' : '1.4'
        }}>
          4. Podstawa prawna przetwarzania
        </h2>
        <p style={{ 
          marginBottom: isSmallMobile ? '12px' : isMobile ? '14px' : '15px',
          lineHeight: isSmallMobile ? '1.4' : '1.6'
        }}>
          Przetwarzanie danych odbywa się na podstawie:
        </p>
        <ul style={{ 
          marginBottom: isSmallMobile ? '12px' : isMobile ? '14px' : '15px', 
          paddingLeft: isSmallMobile ? '15px' : '20px',
          lineHeight: isSmallMobile ? '1.4' : '1.6'
        }}>
          <li>Art. 6 ust. 1 lit. b) RODO - wykonanie umowy</li>
          <li>Art. 6 ust. 1 lit. f) RODO - uzasadniony interes administratora</li>
          <li>Art. 6 ust. 1 lit. a) RODO - zgoda użytkownika (w określonych przypadkach)</li>
        </ul>

        <h2 style={{ 
          fontSize: isSmallMobile ? '20px' : isMobile ? '22px' : '24px', 
          fontWeight: '600', 
          marginBottom: isSmallMobile ? '15px' : isMobile ? '18px' : '20px', 
          color: '#424242', 
          marginTop: isSmallMobile ? '25px' : isMobile ? '28px' : '30px',
          lineHeight: isSmallMobile ? '1.3' : '1.4'
        }}>
          5. Okres przechowywania danych
        </h2>
        <p style={{ 
          marginBottom: isSmallMobile ? '12px' : isMobile ? '14px' : '15px',
          lineHeight: isSmallMobile ? '1.4' : '1.6'
        }}>
          Dane osobowe są przechowywane przez okres:
        </p>
        <ul style={{ 
          marginBottom: isSmallMobile ? '12px' : isMobile ? '14px' : '15px', 
          paddingLeft: isSmallMobile ? '15px' : '20px',
          lineHeight: isSmallMobile ? '1.4' : '1.6'
        }}>
          <li>Dane konta użytkownika: do momentu usunięcia konta</li>
          <li>Dane płatności: zgodnie z wymogami prawnymi (do 5 lat)</li>
          <li>Logi techniczne: do 12 miesięcy</li>
          <li>Dane marketingowe: do momentu wycofania zgody</li>
        </ul>

        <h2 style={{ 
          fontSize: isSmallMobile ? '20px' : isMobile ? '22px' : '24px', 
          fontWeight: '600', 
          marginBottom: isSmallMobile ? '15px' : isMobile ? '18px' : '20px', 
          color: '#424242', 
          marginTop: isSmallMobile ? '25px' : isMobile ? '28px' : '30px',
          lineHeight: isSmallMobile ? '1.3' : '1.4'
        }}>
          6. Udostępnianie danych
        </h2>
        <p style={{ 
          marginBottom: isSmallMobile ? '12px' : isMobile ? '14px' : '15px',
          lineHeight: isSmallMobile ? '1.4' : '1.6'
        }}>
          Dane mogą być udostępniane:
        </p>
        <ul style={{ 
          marginBottom: isSmallMobile ? '12px' : isMobile ? '14px' : '15px', 
          paddingLeft: isSmallMobile ? '15px' : '20px',
          lineHeight: isSmallMobile ? '1.4' : '1.6'
        }}>
          <li>Operatorom płatności (PayPal, Przelewy24, Google Play) w celu realizacji płatności</li>
          <li>Google Play Store w przypadku subskrypcji mobilnych</li>
          <li>Dostawcom usług hostingowych i technicznych (Firebase, Google Cloud)</li>
          <li>Organom państwowym na podstawie przepisów prawa</li>
          <li>Innym podmiotom wyłącznie za wyraźną zgodą użytkownika</li>
        </ul>

        <div style={{
          background: '#e3f2fd',
          border: '2px solid #2196f3',
          borderRadius: isSmallMobile ? '6px' : '8px',
          padding: isSmallMobile ? '15px' : '20px',
          marginBottom: isSmallMobile ? '15px' : '20px'
        }}>
          <h3 style={{ 
            fontSize: isSmallMobile ? '16px' : '18px', 
            fontWeight: '600', 
            marginBottom: isSmallMobile ? '12px' : '15px', 
            color: '#1565c0',
            lineHeight: isSmallMobile ? '1.3' : '1.4'
          }}>
            🔒 Subskrypcje Google Play
          </h3>
          <p style={{ 
            marginBottom: isSmallMobile ? '8px' : '10px', 
            color: '#1565c0',
            lineHeight: isSmallMobile ? '1.4' : '1.6'
          }}>
            <strong>Dane płatności w Google Play:</strong>
          </p>
          <ul style={{ 
            marginBottom: isSmallMobile ? '8px' : '10px', 
            paddingLeft: isSmallMobile ? '15px' : '20px', 
            color: '#1565c0',
            lineHeight: isSmallMobile ? '1.4' : '1.6'
          }}>
            <li>Dane płatnicze są obsługiwane wyłącznie przez Google Play</li>
            <li>Administrator aplikacji nie przechowuje danych płatniczych</li>
            <li>Google Play odpowiada za realizację płatności i faktury</li>
            <li>Subskrypcja podlega regulaminowi Google Play Store</li>
          </ul>
        </div>

        <h2 style={{ 
          fontSize: isSmallMobile ? '20px' : isMobile ? '22px' : '24px', 
          fontWeight: '600', 
          marginBottom: isSmallMobile ? '15px' : isMobile ? '18px' : '20px', 
          color: '#424242', 
          marginTop: isSmallMobile ? '25px' : isMobile ? '28px' : '30px',
          lineHeight: isSmallMobile ? '1.3' : '1.4'
        }}>
          7. Prawa użytkownika
        </h2>
        <p style={{ 
          marginBottom: isSmallMobile ? '12px' : isMobile ? '14px' : '15px',
          lineHeight: isSmallMobile ? '1.4' : '1.6'
        }}>
          Użytkownik ma prawo do:
        </p>
        <ul style={{ 
          marginBottom: isSmallMobile ? '12px' : isMobile ? '14px' : '15px', 
          paddingLeft: isSmallMobile ? '15px' : '20px',
          lineHeight: isSmallMobile ? '1.4' : '1.6'
        }}>
          <li>Dostępu do swoich danych osobowych</li>
          <li>Sprostowania nieprawidłowych danych</li>
          <li>Usunięcia danych ("prawo do bycia zapomnianym")</li>
          <li>Ograniczenia przetwarzania</li>
          <li>Przenoszenia danych</li>
          <li>Wniesienia sprzeciwu</li>
          <li>Wycofania zgody w dowolnym momencie</li>
        </ul>

        <h2 style={{ 
          fontSize: isSmallMobile ? '20px' : isMobile ? '22px' : '24px', 
          fontWeight: '600', 
          marginBottom: isSmallMobile ? '15px' : isMobile ? '18px' : '20px', 
          color: '#424242', 
          marginTop: isSmallMobile ? '25px' : isMobile ? '28px' : '30px',
          lineHeight: isSmallMobile ? '1.3' : '1.4'
        }}>
          8. Bezpieczeństwo danych
        </h2>
        <p style={{ 
          marginBottom: isSmallMobile ? '12px' : isMobile ? '14px' : '15px',
          lineHeight: isSmallMobile ? '1.4' : '1.6'
        }}>
          Stosujemy odpowiednie środki techniczne i organizacyjne, aby chronić dane osobowe przed:
        </p>
        <ul style={{ 
          marginBottom: isSmallMobile ? '12px' : isMobile ? '14px' : '15px', 
          paddingLeft: isSmallMobile ? '15px' : '20px',
          lineHeight: isSmallMobile ? '1.4' : '1.6'
        }}>
          <li>Nieuprawnionym dostępem</li>
          <li>Utratą, zniszczeniem lub uszkodzeniem</li>
          <li>Nieuprawnionym ujawnieniem</li>
          <li>Nieuprawnioną modyfikacją</li>
        </ul>

        <h2 style={{ 
          fontSize: isSmallMobile ? '20px' : isMobile ? '22px' : '24px', 
          fontWeight: '600', 
          marginBottom: isSmallMobile ? '15px' : isMobile ? '18px' : '20px', 
          color: '#424242', 
          marginTop: isSmallMobile ? '25px' : isMobile ? '28px' : '30px',
          lineHeight: isSmallMobile ? '1.3' : '1.4'
        }}>
          9. Pliki cookies
        </h2>
        <p style={{ 
          marginBottom: isSmallMobile ? '12px' : isMobile ? '14px' : '15px',
          lineHeight: isSmallMobile ? '1.4' : '1.6'
        }}>
          Aplikacja używa plików cookies w celu:
        </p>
        <ul style={{ 
          marginBottom: isSmallMobile ? '12px' : isMobile ? '14px' : '15px', 
          paddingLeft: isSmallMobile ? '15px' : '20px',
          lineHeight: isSmallMobile ? '1.4' : '1.6'
        }}>
          <li>Zapewnienia prawidłowego funkcjonowania aplikacji</li>
          <li>Zapamiętywania preferencji użytkownika</li>
          <li>Analizy ruchu i poprawy wydajności</li>
          <li>Personalizacji treści</li>
        </ul>

        <h2 style={{ 
          fontSize: isSmallMobile ? '20px' : isMobile ? '22px' : '24px', 
          fontWeight: '600', 
          marginBottom: isSmallMobile ? '15px' : isMobile ? '18px' : '20px', 
          color: '#424242', 
          marginTop: isSmallMobile ? '25px' : isMobile ? '28px' : '30px',
          lineHeight: isSmallMobile ? '1.3' : '1.4'
        }}>
          10. Kontakt
        </h2>
        <p style={{ 
          marginBottom: isSmallMobile ? '12px' : isMobile ? '14px' : '15px',
          lineHeight: isSmallMobile ? '1.4' : '1.6'
        }}>
          W sprawach związanych z ochroną danych osobowych można kontaktować się z nami:
        </p>
        <p style={{ 
          marginBottom: isSmallMobile ? '12px' : isMobile ? '14px' : '15px',
          lineHeight: isSmallMobile ? '1.4' : '1.6'
        }}>
          Email: kontakt@losuje.pl<br />
          Michal Jedynasty
        </p>

        <h2 style={{ 
          fontSize: isSmallMobile ? '20px' : isMobile ? '22px' : '24px', 
          fontWeight: '600', 
          marginBottom: isSmallMobile ? '15px' : isMobile ? '18px' : '20px', 
          color: '#424242', 
          marginTop: isSmallMobile ? '25px' : isMobile ? '28px' : '30px',
          lineHeight: isSmallMobile ? '1.3' : '1.4'
        }}>
          11. Zmiany w polityce prywatności
        </h2>
        <p style={{ 
          marginBottom: isSmallMobile ? '12px' : isMobile ? '14px' : '15px',
          lineHeight: isSmallMobile ? '1.4' : '1.6'
        }}>
          Zastrzegamy sobie prawo do wprowadzania zmian w niniejszej Polityce Prywatności. 
          O wszelkich zmianach będziemy informować użytkowników poprzez aplikację lub email.
        </p>

        <h2 style={{ 
          fontSize: isSmallMobile ? '20px' : isMobile ? '22px' : '24px', 
          fontWeight: '600', 
          marginBottom: isSmallMobile ? '15px' : isMobile ? '18px' : '20px', 
          color: '#424242', 
          marginTop: isSmallMobile ? '25px' : isMobile ? '28px' : '30px',
          lineHeight: isSmallMobile ? '1.3' : '1.4'
        }}>
          12. Postanowienia końcowe
        </h2>
        <p style={{ 
          marginBottom: isSmallMobile ? '12px' : isMobile ? '14px' : '15px',
          lineHeight: isSmallMobile ? '1.4' : '1.6'
        }}>
          Niniejsza Polityka Prywatności wchodzi w życie z dniem publikacji. 
          Korzystanie z aplikacji oznacza akceptację niniejszej polityki.
        </p>
        <p style={{ 
          marginBottom: isSmallMobile ? '12px' : isMobile ? '14px' : '15px',
          lineHeight: isSmallMobile ? '1.4' : '1.6'
        }}>
          <strong>Ostatnia aktualizacja:</strong> {new Date().toLocaleDateString('pl-PL')}
        </p>
      </div>
    </div>
  );
};

export default PrivacyPolicy;

